import React from "react"
import PropTypes from "prop-types"

import { useTranslation } from "react-i18next"

import Delete from "components/GenericViews/Delete"
import { reverse } from "utils/urls"

export default function RoutingDelete(props) {
  const { t } = useTranslation()

  return (
    <Delete
      modelName={t("Routing")}
      endpoint={`/routings/${props.match.params.id}/`}
      successRoute={reverse("routingList")}
      errorRoute={reverse("routingDetail", { id: props.match.params.id })}
    />
  )
}

RoutingDelete.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
